import { Aspect } from '@teambit/harmony';

export const InstallAspect = Aspect.create({
  id: 'teambit.workspace/install',
});
